import { heroData } from '@/mocks/homeData';

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen w-full flex items-center bg-background-50 overflow-hidden pt-20"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-100/30 via-background-50 to-accent-100/20"></div>

      <div className="relative w-full max-w-[1440px] mx-auto px-4 md:px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium tracking-wide mb-5">
              {heroData.label}
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight mb-4">
              {heroData.h1}
            </h1>

            <p className="text-lg md:text-xl text-primary-600 font-medium mb-6">
              {heroData.slogan}
            </p>

            <p className="text-base text-foreground-600 leading-relaxed max-w-xl lg:max-w-none mb-8">
              {heroData.description}
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 md:gap-10 mb-8">
              {heroData.stats.map((stat) => (
                <div key={stat.label} className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-foreground-900">{stat.value}</div>
                  <div className="text-sm text-foreground-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href={heroData.primaryCta.href}
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-colors duration-200"
              >
                {heroData.primaryCta.label}
                <i className="ri-arrow-right-line"></i>
              </a>
              <a
                href={heroData.secondaryCta.href}
                className="whitespace-nowrap cursor-pointer inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-base hover:border-primary-300 hover:text-primary-600 transition-colors duration-200"
              >
                {heroData.secondaryCta.label}
                <i className="ri-bar-chart-line"></i>
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[520px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20imperial%20palace%20drama%20cinematic%20scene%20with%20a%20determined%20young%20woman%20in%20elaborate%20Qing%20dynasty%20silk%20costume%20with%20intricate%20embroidery%20standing%20in%20magnificent%20palace%20hall%2C%20warm%20golden%20lantern%20light%20casting%20dramatic%20shadows%2C%20ornate%20carved%20wooden%20pillars%2C%20rich%20crimson%20and%20gold%20color%20palette%2C%20epic%20cinematic%20composition%2C%20soft%20atmospheric%20haze%2C%20editorial%20photography%20quality&width=1040&height=780&seq=hero-main-visual&orientation=landscape"
                alt="吃瓜视频 - 热门剧集高清播放平台"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 bg-white/90 backdrop-blur-sm rounded-lg px-4 py-2">
                <span className="text-sm font-semibold text-primary-700">延禧攻略 全集高清</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}